// games/registry.js
// The single registration point for all frontend games.
// To add a new game: import the component and add one entry below.

import Hangman      from './Hangman';
import OneWordStory from './OneWordStory';
export const GAME_REGISTRY = {
  hangman: {
    component: Hangman,
    label:     "Let's play Hangman?",
    emoji:     '🔤',
    display:   'Hangman',
  },
  story: {
    component: OneWordStory,
    label:     "Let's play One Word Story?",
    emoji:     '📖',
    display:   'One Word Story',
  },
};